import { Avatar, Grid, IconButton, Typography } from "@mui/material";
import { AppImages } from "app/appImages";
import { MprcContainer, MprcLink, MprcRequestErrorDialog, MprcSpinnerIndicator, MprcTextMuted } from "components";
import { TrainingSpecialistResponse } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import { useModalUserProfile } from "providers/UserProfileProvider";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    trainingId: string;
}

/**
 * Painel lateral de especialistas do treinamento.
 * @param props
 */
export const TrainingViewSpecialistBox: React.FC<IProps> = (props) => {
    const { trainingId } = props;

    const api = useCoreApi();
    const { t } = useTranslation("lms");
    const { showUser } = useModalUserProfile();

    const [users, setUsers] = useState<TrainingSpecialistResponse[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [viewError, setViewError] = useState<any>();

    useEffect(() => {
        async function getData() {
            try {
                var result = await api.v1.enrollment.getTrainingPanelSpecialists({
                    trainingId
                });
                setUsers(result.data);
            } catch (e) {
                setViewError(e);
            } finally {
                setLoading(false);
            }
        }

        if (loading) getData();

    }, [loading]);

    return (
        <>
            <MprcRequestErrorDialog error={viewError} onClose={() => setViewError(undefined)} />
            {
                loading
                    ? (
                        <MprcContainer margin="dense">
                            <MprcSpinnerIndicator />
                        </MprcContainer>
                    )
                    : (
                        <>
                            {users.length > 0 &&
                                <div>
                                    <MprcContainer margin="dense">
                                        <Typography variant="h3">{t("Student.EnrollmentView.SpecialistBox.Title")}</Typography>
                                    </MprcContainer>
                                    {users.map(item =>
                                        <div key={item.userId}>
                                            <Grid container alignItems="center" spacing={0.5} wrap="nowrap">
                                                <Grid>
                                                    <IconButton disableRipple disableFocusRipple onClick={() => showUser(item.userId)}>
                                                        <Avatar
                                                            src={item.thumbnailUrl ?? AppImages.UserThumbnail}
                                                            sx={(theme) => ({ width: 32, height: 32, backgroundColor: theme.palette.grey[200] })}
                                                        />
                                                    </IconButton>
                                                </Grid>
                                                <Grid>
                                                    <MprcTextMuted>
                                                        <MprcLink onClick={() => showUser(item.userId)} fontSize="inherit">
                                                            <Typography variant="body2" component="div" noWrap>
                                                                {item.name}
                                                            </Typography>
                                                        </MprcLink>
                                                    </MprcTextMuted>
                                                    {
                                                        item.unitName &&
                                                        <MprcTextMuted>
                                                            <Typography variant="caption" component="div" noWrap>
                                                                {item.unitName}
                                                            </Typography>
                                                        </MprcTextMuted>
                                                    }
                                                </Grid>
                                            </Grid>
                                        </div>
                                    )}
                                </div>
                            }
                        </>
                    )
            }
        </>
    );
};
